module.exports = __webpack_public_path__ + "static/media/multimedia-music-player-play-button.000d20f6.svg";